import http from "./http";
import type {
  RentalProperty,
  RentalPropertyListResponse,
  RentalPropertyFilter,
  RentalRequest,
  RentalRequestListResponse,
  RentalRequestFilter,
} from "@/types";

export const rentalApi = {
  /* ── Cho thuê ── */
  getProperties: (params: RentalPropertyFilter) =>
    http
      .get<RentalPropertyListResponse>("/properties", { params })
      .then((r) => r.data),

  getGuestProperties: (params: RentalPropertyFilter) =>
    http
      .get<RentalPropertyListResponse>("/guest-properties", { params })
      .then((r) => r.data),

  getPropertyById: (id: string) =>
    http.get<RentalProperty>(`/properties/${id}`).then((r) => r.data),

  createProperty: (data: any) =>
    http.post<RentalProperty>("/properties", data).then((r) => r.data),

  updateProperty: (id: string, data: any) =>
    http.patch<RentalProperty>(`/properties/${id}`, data).then((r) => r.data),

  /* ── Nhận thuê ── */
  getRentalRequests: (params: RentalRequestFilter) =>
    http
      .get<RentalRequestListResponse>("/fnb-rental-requests", { params })
      .then((r) => r.data),

  getGuestRentalRequests: (params: RentalRequestFilter) =>
    http
      .get<RentalRequestListResponse>("/guest-rental-requests", { params })
      .then((r) => r.data),

  getRentalRequestById: (id: string) =>
    http.get<RentalRequest>(`/fnb-rental-requests/${id}`).then((r) => r.data),

  createRentalRequest: (data: any) =>
    http.post<RentalRequest>("/fnb-rental-requests", data).then((r) => r.data),

  updateRentalRequest: (id: string, data: any) =>
    http.patch<RentalRequest>(`/fnb-rental-requests/${id}`, data).then((r) => r.data),

};

